<app-shpo [project_id]="project_id" style="display: flex; flex: 1;"></app-shpo>

<app-tcp [project_id]="project_id" style="display: flex; flex: 1;"></app-tcp>

<app-sites-in-ape [project_id]="project_id" style="display: flex; flex: 1;"> </app-sites-in-ape>
